module.exports = __webpack_public_path__ + "img/section5-item3.7f05da9b.png";